import { getReportShopping } from "@/functions/databaseData";
import currency from "@/functions/currency";
import {
  ChevronDownSvg,
  ChevronUpSvg,
  EyeOnSvg,
  PaperDownloadSolidSvg,
  SearchSvg,
} from "@/public/svg";
import xlsx from "json-as-xlsx";
import { useCallback, useEffect, useMemo, useState } from "react";
import { twMerge } from "tailwind-merge";
import { FooterTable } from "../../../_component";
import { toast } from "react-toastify";
import InputTitle from "@/components/sub-atom/InputTitle";
import Input from "@/components/atom/Input";
import Divider from "@/components/atom/Divider";
import Button from "@/components/atom/Button";
import checkLevel from "@/functions/checkLevel";
import { ScrollPagination } from "@/components/atom/Pagination";
import Label from "@/components/sub-atom/Label";
import { formatExcelLaporanBelanja } from "@/functions/formatExcel";
import useHeader from "@/functions/useHeader";

const title = {
  expired: "expired",
  canceled: "canceled",
  booking: "booking",
  ["on-process"]: "process",
  ["on-packing"]: "packing",
  ["on-delivery"]: "on delivered",
  received: "received",
  completed: "completed",

  // type payment
  paylater: "paylater",
  payment_gateway: "Via Online",
  COD: "cash on delivery",
  cash: "cash",

  // status pembayaran
  pending: "PENDING",
  paid: "PAID",
};

const colors = {
  expired: "orange",
  canceled: "errorGON",
  booking: "warningGON",
  ["on-process"]: "teal",
  ["on-packing"]: "cyan",
  ["on-delivery"]: "secondaryGON",
  received: "successGON",
  completed: "primaryGON",

  // type payment
  paylater: "secondary",
  payment_gateway: "primary",
  COD: "greyscale",
  cash: "warning",

  // status pembayaran
  pending: "cyan",
  paid: "success",
};

export default function LaporanBelanjaJaringan({
  runGetDetailOrder,
  datas,
  date,
  user,
  range_date,
}) {
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState({});
  const [listReportAllDownline, setListReportAllDownline] = useState({});
  const { session } = useHeader();

  async function handleDownloadexcel() {
    try {
      setLoading((old) => ({ ...old, exportDataAll: true }));

      const newArr = [];
      Object.entries(listReportAllDownline ?? {})?.map(([key, item], index) => {
        item?.transaction_mitra?.map((val, index) => {
          newArr.push({
            ...val,
            mitra_upline: session?.user?.data?.name_store,
          });
        });
      });

      const dataExport = newArr;
      if (dataExport?.length <= 0 || !dataExport)
        return toast.warning("Data not found", { position: "top-center" });

      formatExcelLaporanBelanja(
        dataExport
          ?.map((a) => {
            a.mitra_upline = session?.user?.data?.name_store;
            return a;
          })
          ?.sort((a, b) => new Date(b?.created_at) - new Date(a?.created_at)),
        range_date
      );
    } catch (error) {
      console.log(error?.message);
      toast.error(`Error export file : ${error?.message}`, {
        position: "top-center",
      });
    } finally {
      setLoading((old) => ({ ...old, exportDataAll: false }));
    }
  }

  const isDatas = useMemo(() => {
    return datas?.filter((item) => {
      return search?.length > 0
        ? item?.name_store?.toLowerCase()?.includes(search?.toLowerCase())
        : item;
    });
  }, [search, datas]);

  return (
    <div
      className=' bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 xs:p-8
      flex flex-col gap-3 xs:gap-6
      '>
      <div className='flex flex-col md:flex-row gap-4 md:gap-8 md:items-center justify-between'>
        <p className='subheading-semiBold text-greyscaleGON-700'>
          Laporan Belanja Jaringan
        </p>
        <p className='p1-regular text-greyscaleGON-400'>{range_date}</p>
      </div>
      <div className='flex flex-col gap-4'>
        <InputTitle title={"cari akun"} />
        <div className='flex flex-col xs:flex-row xs:items-center justify-between gap-8'>
          <div className='w-full xs:w-[322px]'>
            <Input
              icon={{
                right: (props) => <SearchSvg {...props} />,
              }}
              onChange={(val) => setSearch(val)}
              value={search}
              onSubmit={(e) => e.preventDefault()}
              enterKeyHint={"search"}
              placeholder='Cari nama toko'
            />
          </div>

          <Button
            label='Export all to Excel'
            colors='secondary'
            disable={
              Object.entries(listReportAllDownline ?? {})?.length <= 0 ||
              loading?.exportDataAll
            }
            loading={loading?.exportDataAll}
            variants='outline'
            icon={{
              left: (props) => <PaperDownloadSolidSvg {...props} />,
            }}
            onClick={() => handleDownloadexcel()}
          />
        </div>
      </div>
      <Divider />
      <div>
        {isDatas?.length <= 0 ? (
          <div className='min-h-[250px] flex justify-center items-center'>
            <p className='p1-medium text-greyscaleGON-400 text-center'>
              Belum Ada Rekapan Penjualan <br /> pada rentang waktu{" "}
              <span className='text-greyscaleGON-700'>{range_date}</span>
            </p>
          </div>
        ) : (
          <div className='flex flex-col gap-2'>
            {isDatas?.map((item, index) => (
              <ComponentReportShoppingDownline
                key={index}
                date={date}
                index={index}
                item={item}
                user={user}
                runGetDetailOrder={runGetDetailOrder}
                range_date={range_date}
                setListReportAllDownline={setListReportAllDownline}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function ComponentReportShoppingDownline({
  date,
  user,
  item,
  index,
  runGetDetailOrder,
  range_date,
  setListReportAllDownline,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState({});
  const [show, setShow] = useState(0);
  const [showScrollPagination, setShowScrollPagination] = useState(0);
  const [datas, setDatas] = useState({});
  const { session } = useHeader();
  const headList = [
    "No.",
    "Tanggal",
    "No. Order",
    "Qty",
    "Disc",
    "Sub harga produk",
    "Ongkir",
    "Total Tagihan",
    "Status",
    "Aksi",
  ];

  const listTypeProduct = useMemo(
    () => [
      {
        id: 0,
        title: "all",
        value: datas?.transaction_mitra,
        status: showScrollPagination == 0 ? "active" : "noActive",
      },
      {
        id: 1,
        title: "booking",
        actionType: "on-process",
        value: datas?.transaction_mitra?.filter(
          (val) => val?.status == "booking"
        ),
        status: showScrollPagination == 1 ? "active" : "noActive",
      },
      {
        id: 3,
        title: "on-process",
        actionType: "on-packing",
        value: datas?.transaction_mitra?.filter(
          (val) => val?.status == "on-process"
        ),
        status: showScrollPagination == 3 ? "active" : "noActive",
      },
      {
        id: 4,
        title: "on-packing",
        actionType: "on-delivery",
        value: datas?.transaction_mitra?.filter(
          (val) => val?.status == "on-packing"
        ),
        status: showScrollPagination == 4 ? "active" : "noActive",
      },
      {
        id: 5,
        title: "on-delivery",
        value: datas?.transaction_mitra?.filter(
          (val) => val?.status == "on-delivery"
        ),
        status: showScrollPagination == 5 ? "active" : "noActive",
      },
      {
        id: 6,
        title: "received",
        value: datas?.transaction_mitra?.filter(
          (val) => val?.status == "received"
        ),
        status: showScrollPagination == 6 ? "active" : "noActive",
      },
      {
        id: 7,
        title: "completed",
        value: datas?.transaction_mitra?.filter(
          (val) => val?.status == "completed"
        ),
        status: showScrollPagination == 7 ? "active" : "noActive",
      },
      {
        id: 8,
        title: "canceled",
        value: datas?.transaction_mitra?.filter(
          (val) => val?.status == "canceled"
        ),
        status: showScrollPagination == 8 ? "active" : "noActive",
      },
      {
        id: 9,
        title: "expired",
        value: datas?.transaction_mitra?.filter(
          (val) => val?.status == "expired"
        ),
        status: showScrollPagination == 9 ? "active" : "noActive",
      },
    ],
    [datas?.transaction_mitra, showScrollPagination]
  );

  useEffect(() => {
    if (user) {
      runGetListOrder();
    }
  }, [user, date]);

  const runGetListOrder = useCallback(async () => {
    let payload = {
      date_from: `${date?.date_from?.replaceAll("/", "-")}`,
      date_until: `${date?.date_until?.replaceAll("/", "-")}`,
    };

    const resDatas = await getReportShopping({
      mitra_id: item?.mitra_id,
      token: user?.token,
      ...payload,
    });
    setDatas(resDatas);
    setListReportAllDownline((old) => ({
      ...old,
      [item?.name_store]: resDatas,
    }));
  }, [user, date]);

  const { currentTableData, listTotalBelanja } = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;

    const isListOrders = listTypeProduct
      ?.filter((val1) => val1?.id == showScrollPagination)?.[0]
      ?.value?.filter((item) => {
        return item;
      });

    const listTotalBelanja = [
      {
        title: "Jumlah Order",
        value: isListOrders?.length ?? 0,
      },
      {
        title: "Jumlah Produk",
        value: `${
          isListOrders?.reduce((a, c) => a + c?.total_products_qty, 0) ?? 0
        } pcs`,
      },
      {
        title: "Sub Harga Produk",
        value: currency(
          isListOrders?.reduce(
            (a, c) => a + c?.total_product_harga_normal,
            0
          ) ?? 0
        ),
      },
      {
        title: "Total Ongkir",
        value: currency(
          isListOrders?.reduce((a, c) => a + c?.biaya_pengiriman, 0) ?? 0
        ),
      },
      {
        title: "Total Tagihan",
        value: currency(
          isListOrders?.reduce((a, c) => a + c?.total_pembayaran, 0) ?? 0
        ),
        colors: "primary",
      },
    ];

    return {
      currentTableData: isListOrders?.slice(firstPageIndex, lastPageIndex),
      listTotalBelanja,
    };
  }, [pageSize, currentPage, datas, showScrollPagination, listTypeProduct]);

  async function handleDownloadexcel() {
    try {
      setLoading((old) => ({ ...old, exportData: true }));

      const dataExport = datas?.transaction_mitra;
      const activeTabStatus = listTypeProduct?.filter(
        (val1) => val1?.id == showScrollPagination
      )?.[0]?.title;

      if (dataExport?.length <= 0 || !dataExport)
        return toast.warning("Data not found", { position: "top-center" });

      formatExcelLaporanBelanja(
        dataExport
          ?.map((a) => {
            a.mitra_upline = session?.user?.data?.name_store;
            return a;
          })
          ?.filter((val) =>
            activeTabStatus == "all" ? val : val?.status == activeTabStatus
          )
          ?.sort((a, b) => new Date(b?.created_at) - new Date(a?.created_at)),
        datas?.range_date
      );
    } catch (error) {
      console.log(error?.message);
      toast.error(`Error export file : ${error?.message}`, {
        position: "top-center",
      });
    } finally {
      setLoading((old) => ({ ...old, exportData: false }));
    }
  }

  return (
    <div className='flex flex-col p-4 bg-greyscaleGON-50 gap-6'>
      <div
        className={twMerge(
          `z-[5] flex flex-col xs:flex-row justify-between xs:items-center gap-4`
        )}>
        <div className='flex flex-col gap-1 w-[80%]'>
          <p className='p1-medium text-greyscaleGON-700'>{item?.name_store}</p>
          <p className='p2-regular text-greyscaleGON-400'>
            {checkLevel(item?.mitra_level)}
          </p>
        </div>
        {show?.[index] ? (
          <div className='flex flex-row items-center gap-4'>
            <Button
              label='Export to Excel'
              colors='secondary'
              disable={
                !datas ||
                datas?.transaction_mitra?.length <= 0 ||
                loading?.exportData
              }
              loading={loading?.exportData}
              variants='outline'
              icon={{
                left: (props) => <PaperDownloadSolidSvg {...props} />,
              }}
              onClick={handleDownloadexcel}
            />
            <div
              className='cursor-pointer'
              onClick={(e) => {
                e.preventDefault();
                setShow((old) => ({ ...old, [index]: !show?.[index] }));
              }}>
              <ChevronUpSvg className='h-6 w-6 text-greyscaleGON-400' />
            </div>
          </div>
        ) : (
          <div
            className='cursor-pointer flex flex-row items-center gap-4'
            onClick={(e) => {
              e.preventDefault();
              setShow((old) => ({ ...old, [index]: !show?.[index] }));
            }}>
            <div>
              <p className='p1-medium text-greyscaleGON-700'>
                {currency(datas?.sum_bill ?? 0)}
              </p>
            </div>
            <div>
              <ChevronDownSvg className='h-6 w-6 text-greyscaleGON-400' />
            </div>
          </div>
        )}
      </div>
      {!show?.[index] ? null : (
        <>
          <div className='flex flex-col gap-2'>
            <ScrollPagination
              datas={listTypeProduct}
              className='flex flex-row gap-2 w-full'
              renderItem={({ item, index }) => {
                const colors = {
                  active: "primaryGON",
                  noActive: "greyscaleGON",
                };
                return (
                  <div
                    key={index}
                    onClick={() => {
                      setPageSize(10);
                      setCurrentPage(1);
                      setShowScrollPagination(item?.id);
                    }}
                    className='flex flex-col items-center gap-3 cursor-pointer'>
                    <div className='gap-2 px-4 flex items-center'>
                      <p
                        className={`p1-medium whitespace-nowrap  capitalize text-${
                          colors?.[item?.status]
                        }-${item?.status == "active" ? "400" : "700"} `}>
                        {item?.subTitle ?? item?.title}
                      </p>
                      <p
                        className={`text-button-medium ml-2 rounded-lg border border-${
                          colors?.[item?.status]
                        }-50 bg-${colors?.[item?.status]}-50 px-2 py-1 text-${
                          colors?.[item?.status]
                        }-400 group-focus-visible:border-${
                          colors?.[item?.status]
                        }-200`}>
                        {item?.value?.length > 99 ? "99+" : item?.value?.length}
                      </p>
                    </div>
                    {item?.status == "active" && (
                      <div
                        className={`flex h-1 w-full rounded-tl-xl rounded-tr-xl bg-${
                          colors?.[item?.status]
                        }-400`}
                      />
                    )}
                  </div>
                );
              }}
            />
          </div>
          <div className=' overflow-hidden overflow-x-scroll'>
            <table className='table-auto w-full'>
              <thead>
                <tr>
                  {headList?.map((item, index) => (
                    <th
                      key={index}
                      // className={twMerge("p-4", index === 0 ? "w-32" : " w-32")}
                      className={twMerge(
                        "py-4 border-b-[1px] border-t-[1px] border-greyscaleGON-200"
                      )}>
                      <div className='flex items-center gap-2 justify-between'>
                        <p className='capitalize text-start p2-medium text-greyscaleGON-400 max-w-full whitespace-nowrap overflow-hidden text-ellipsis'>
                          {item}
                        </p>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className='bg-shadesGON-50'>
                {currentTableData?.map((item, index) => (
                  <tr key={(currentPage - 1) * pageSize + (index + 1)}>
                    <td>{(currentPage - 1) * pageSize + (index + 1)}.</td>
                    <td>
                      <p className='max-w-full whitespace-nowrap overflow-hidden text-ellipsis capitalize p1-regular text-greyscaleGON-700'>
                        {item?.created_at}
                      </p>
                    </td>
                    <td>
                      <p className='max-w-full whitespace-nowrap overflow-hidden text-ellipsis capitalize p1-regular text-greyscaleGON-700'>
                        {item?.kode_order}
                      </p>
                    </td>
                    <td>
                      <p className='max-w-full whitespace-nowrap overflow-hidden text-ellipsis p1-regular text-greyscaleGON-700'>
                        {item?.total_products_qty}
                      </p>
                    </td>

                    <td>
                      <p className='max-w-full whitespace-nowrap overflow-hidden text-ellipsis p1-regular text-greyscaleGON-700'>
                        {currency(item?.discount)}
                      </p>
                    </td>
                    <td>
                      <p className='max-w-full whitespace-nowrap overflow-hidden text-ellipsis capitalize p1-regular text-greyscaleGON-700'>
                        {currency(item?.total_product_harga_normal)}
                      </p>
                    </td>
                    <td>
                      <p className='max-w-full whitespace-nowrap overflow-hidden text-ellipsis capitalize p1-regular text-greyscaleGON-700'>
                        {currency(item?.biaya_pengiriman)}
                      </p>
                    </td>
                    <td>
                      <p className='max-w-full whitespace-nowrap overflow-hidden text-ellipsis capitalize p1-regular text-greyscaleGON-700'>
                        {currency(item?.total_pembayaran)}
                      </p>
                    </td>
                    <td className={twMerge("pr-4")}>
                      <Label
                        classNameText={
                          "max-w-full whitespace-nowrap overflow-hidden text-ellipsis"
                        }
                        className={"justify-center"}
                        title={title?.[item?.status] ?? item?.status}
                        univColor={true}
                        colors={colors?.[item?.status] ?? "greyscale"}
                      />
                    </td>
                    <td className='flex gap-2 items-center py-2'>
                      <div
                        onClick={() => runGetDetailOrder(item)}
                        className='cursor-pointer relative group'>
                        <EyeOnSvg className='text-primaryGON-400 w-6 h-6 xs:w-8 xs:h-8' />
                        <div className='group-hover:visible group-hover:opacity-100 invisible opacity-10 transition-all'>
                          <span
                            className={twMerge(
                              "absolute inline-block bg-neutral-500 text-white rounded-md",
                              "left-1/2 -translate-x-1/2 bottom-[calc(100%+5px)]",
                              "z-50",
                              "whitespace-nowrap capitalize p3-medium text-shadesGON-50 px-2 py-1"
                            )}>
                            Detail order
                          </span>
                          <span className='absolute inline-block border-[8px] left-1/2 -translate-x-1/2 bottom-full border-l-transparent border-r-transparent border-b-0 border-t-neutral-500' />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <FooterTable
              currentPage={currentPage}
              totalCount={datas?.length}
              pageSize={pageSize}
              setPageSize={setPageSize}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
          <div
            className='grid grid-cols-1 xs:grid-cols-2 md:grid-cols-4 lg:grid-cols-5
      gap-4 items-center '>
            {listTotalBelanja?.map((item, index) => (
              <div
                key={index}
                className={twMerge(
                  `py-6 px-4 flex flex-col gap-3 border border-greyscaleGON-200 rounded-lg bg-shadesGON-50`
                )}>
                <p className='p2-regular text-greyscaleGON-400'>
                  {item?.title}
                </p>
                <p
                  className={`p1-semiBold text-${
                    item?.colors ? "primaryGON-400" : "greyscaleGON-700"
                  }`}>
                  {item?.value}
                </p>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
